import React, {useEffect, useMemo, useState} from 'react';
import styles from "./longCharts.module.scss";
import {Candle, TimeFrames} from "../../../../../../shared/types";
import Chart from "../charts/chart/Chart";
import {useAppSelector} from "../../../../../../store/store";
import {heightCandlestickCanvas, heightCandlestickVolumeCanvas} from "../../../../../../shared/configCanvas";

interface Props {
  active: boolean
  specificityOfRecomendsByStrategy: string
  quotes: Record<TimeFrames, Candle[]>
}

type TfIsActive = 'high' | 'middle' | 'low'

const LongCharts = ({active, specificityOfRecomendsByStrategy, quotes}: Props) => {

  const screenWidth = useAppSelector(state => state.appReduser.screenWidth)

  const strategyHighTf: TimeFrames = useMemo(() => JSON.parse(specificityOfRecomendsByStrategy).highTf, [specificityOfRecomendsByStrategy])

  const [widthWrap, setWidthWrap] = useState<number>()
  const [tfIsActive, setTfIsActive] = useState<TfIsActive>('high')

  //расчет размера canvas
  useEffect(() => {
    if (screenWidth) {
      const width = (screenWidth - 64) * 3 // 45 - это с боков от попапа, 3 - количество графиков
      setWidthWrap(width)
    }
  }, [screenWidth])

  const toggleUpScreen = () => {
    const prevState = tfIsActive
    if (prevState === 'low') {
      setTfIsActive('middle')
    } else if (prevState === 'middle') {
      setTfIsActive('high')
    } else {
      return
    }
  }

  const toggleDownScreen = () => {
    const prevState = tfIsActive
    if (prevState === 'high' && (strategyHighTf !== 'month' && strategyHighTf !== 'week')) {
      setTfIsActive('middle')
    } else if (prevState === 'middle' && strategyHighTf !== 'day') {
      setTfIsActive('low')
    } else {
      return
    }
  }

  return (
    <div className={[styles.container, active ? styles.active : ''].join(' ')}>
      <div className={styles.content}>
        <div className={styles.buttons}>
          <span
            onClick={toggleUpScreen}
            style={{
              backgroundColor: '#f0fff0'
            }}
            onMouseOver={(event) => event.currentTarget.style.background = '#e2eeff'}
            onMouseOut={(event) => event.currentTarget.style.background = '#f0fff0'}
          >
            {
              '<<'
            }
          </span>
          <span
            onClick={toggleDownScreen}
            style={{
              backgroundColor: '#fff0f0',
            }}
            onMouseOver={(event) => event.currentTarget.style.background = '#e2eeff'}
            onMouseOut={(event) => event.currentTarget.style.background = '#fff0f0'}
          >
            {
              '>>'
            }
          </span>
        </div>
        <div
          className={[styles.wrap, tfIsActive === 'high' ? styles.highTfIsActive : tfIsActive === 'middle' ? styles.middleTfIsActive : ''].join(' ')}
          style={{width: `${widthWrap}px`}}
        >
          <Chart active={active} quotes={quotes} tfByRecomendsStrategy={TimeFrames.month}
                 zzByRecomendsStrategy={33}/>
          <Chart active={active} quotes={quotes} tfByRecomendsStrategy={TimeFrames.week}
                 zzByRecomendsStrategy={19}/>
          <Chart active={active} quotes={quotes} tfByRecomendsStrategy={TimeFrames.day}
                 zzByRecomendsStrategy={7.9}/>
        </div>
      </div>
    </div>
  );
};

export default LongCharts;